import { useEffect, useRef } from "react";

export default function StarDust() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        let width = window.innerWidth;
        let height = window.innerHeight;

        canvas.width = width;
        canvas.height = height;

        const STAR_COUNT = 200;
        const stars = [];

        function createStar() {
            return {
                angle: Math.random() * Math.PI * 2,
                distance: Math.random() * 20,
                speed: 0.5 + Math.random() * 1.5,
                opacity: 0.2 + Math.random() * 0.8,
            };
        }

        for (let i = 0; i < STAR_COUNT; i++) {
            stars.push(createStar());
        }

        function resetStar(star) {
            star.angle = Math.random() * Math.PI * 2;
            star.distance = 0;
            star.speed = 0.1 + Math.random() * 0.7;
            star.opacity = 0.2 + Math.random() * 0.8;
        }

        function resize() {
            width = window.innerWidth;
            height = window.innerHeight;

            canvas.width = width;
            canvas.height = height;
        }

        window.addEventListener("resize", resize);

        let animationFrame;

        function animate() {
            ctx.clearRect(0, 0, width, height);

            const centerX = width / 2;
            const centerY = height / 2;
            const maxDistance = Math.sqrt(
                width * width + height * height
            );

            for (const star of stars) {
                star.distance += star.speed;
                star.speed *= 1.008;

                const x =
                    centerX +
                    Math.cos(star.angle) * star.distance;

                const y =
                    centerY +
                    Math.sin(star.angle) * star.distance;

                const alpha =
                    Math.min(
                        1,
                        star.distance / (maxDistance * 0.4)) * star.opacity;

                ctx.globalAlpha = alpha;
                ctx.fillStyle = "#ffffff";
                ctx.fillRect(
                    Math.round(x),
                    Math.round(y),
                    3,
                    3
                );

                if (
                    x < -10 ||
                    x > width + 10 ||
                    y < -10 ||
                    y > height + 10
                ) {
                    resetStar(star);
                }
            }

            animationFrame = requestAnimationFrame(
                animate
            );
        }

        animate();

        return () => {
            cancelAnimationFrame(animationFrame);
            window.removeEventListener("resize", resize);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: "fixed",
                inset: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                background: "transparent",

            }}
        />
    );
}